import { create } from 'zustand';
import { createReport, getObjects } from '../../api/api';
import { toast } from 'react-toastify';
import { formats, TYPE_FORMAT } from './constants';

export const useReportsStore = create((set, get) => ({
  isLoading: false,
  error: null,
  objects: [],
  formats,

  fetchObjects: async () => {
    set({ isLoading: true, error: null });

    await getObjects({
      dataCb: (data) => {
        const objects = data?.map((item) => {
          return { name: `${item?.address ?? ''}, кв ${item?.apartment ?? ''}` ?? item, value: item?.id };
        });
        set({ objects: objects ?? [], isLoading: false });
      },
      errCb: (err) => {
        set({ error: err, isLoading: false });
      },
    });
  },
  handleCreateReport: async (searchValue) => {
    const typeFormat = TYPE_FORMAT[searchValue?.format];

    await createReport({
      searchParams: searchValue,
      typeFormat,
      dataCb: (data) => {
        const blob = new Blob([data], {
          type: typeFormat,
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `report.${searchValue.format}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        toast.success(`Отчет успешно загружен`);
      },
      errCb: (err) => toast.error(`Произошла ошибка: ${err?.error}`),
    });
  },
}));
